import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import TotalReport from '@app/views/Ledger/TotalReport';
import { memo } from 'react';

export default memo(
  withIfUser(TotalReport)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
